<template>
  <div ondragstart="return false" oncontextmenu="return false"  class="all" >
    <ei-home-body :cover="cover" ref="homeBody">
      <template v-slot:one>
        <div class="header">
          <ei-header v-bind:header-show="showHeader" v-bind:header2-show="showHeader2"
                     v-bind:header2-lit="header2Lit"></ei-header>
          <ei-carousel v-bind:carousels="homeCarouselList" v-bind:homeCarouselBgList="homeCarouselBgList"
                       :oneBg="oneBg"></ei-carousel>
        </div>
      </template>
      <template v-slot:two>
        <DropdownPluginWriter class="dropdown-writer"
                              :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie"
                              :lieMarginLeft="lieMarginLeft"
        >
        </DropdownPluginWriter>
        <DropdownPluginPainter class="dropdown-painter"
                               :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie"
                               :lieMarginLeft="lieMarginLeft"
        >
        </DropdownPluginPainter>
        <ei-home-block1 :homeCarousel1smallList="homeCarousel1smallList"></ei-home-block1>
        <ei-home-block2 class="block2-offset"></ei-home-block2>
        <ei-home-block3></ei-home-block3>
        <ei-home-block4 :worksAttach="worksAttach"></ei-home-block4>
        <!--                <ei-home-block5 :home-block-list="homeBlock5.homeBlockList"></ei-home-block5>
                        <ei-home-block6></ei-home-block6>
                        <ei-home-block7></ei-home-block7>-->
        <ei-footer></ei-footer>
      </template>
    </ei-home-body>
    </div>
</template>

<script>
import {
  queryArticleListInHomeAction,
  queryCarouselListInHomeAction,
  queryCarouselBgListInHomeAction,
  queryHomeBlockInHomeAction,
  queryPoemListInHomeAction,
  queryWorksListInHomeAction,
  queryCarousel1smallListInHomeAction, queryCarousel1smallBy9999,

} from '@/api/reception/home-api'
import {isFailure} from '@/eiuov-utils/axios/response'
import {onLoadImg, onLoadImgInWhere, onScrollImg} from '@/eiuov-utils/img-lazy'
import {queryVectorListAction} from '@/api/reception/vector-api'
import {queryEbookListAction} from '@/api/reception/ebook-api'
import {queryVideoListAction} from '@/api/reception/record-api'
import {queryBookListAction} from '@/api/reception/book-api'
import {listToServerUrl} from '@/eiuov-utils/local-dev'
import {queryPersonByCoverArea, queryWorksAttachByTargetInfo} from "@/api/reception/works-api";

export default {
  name: 'Home',
  data() {
    return {
      worksAttach: {},
      homeCarouselList: [],
      homeCarouselBgList: [],
      homeCarousel1smallList: [],
      oneBg: {},
      homeCooperationList: [],
      homeGoodsList: [],
      homeGoodsGroups: [],
      showHeader: false,
      showHeader2: false,
      header2Lit: false,
      screenWidth: document.body.clientWidth,
      cover: false,
      lastScrollTop: 0,
      lieWidth: 26,
      lieHeight: 27,
      lieMarginLeft: -40,
      lieFontSzie: 20,
    }
  },
  created() {
    this.updateLieSize()
    window.addEventListener('resize', this.updateLieSize)
    queryCarouselBgListInHomeAction({}).then((res) => {
      if (isFailure(res)) return
      this.homeCarouselBgList = res.data.list
      this.oneBg = this.homeCarouselBgList.pop()
    })
    queryCarousel1smallListInHomeAction({}).then((res) => {
      if (isFailure(res)) return
      this.homeCarousel1smallList = res.data.list
    })
    queryCarouselListInHomeAction({}).then((res) => {
      if (isFailure(res)) return
      this.homeCarouselList = res.data.list
      //本地获取服务器图片
      //listToServerUrl(this.homeCarouselList)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLieSize)
  },
  mounted() {
    this.initHeader()
  },
  methods: {
    // 以 1920 为设计稿，下拉列表图标/字号随视口等比缩放
    updateLieSize() {
      const scale = document.body.clientWidth / 1920
      this.lieWidth = Math.max(16, Math.round(26 * scale))
      this.lieHeight = Math.max(17, Math.round(27 * scale))
      this.lieMarginLeft = Math.round(-40 * scale)
      this.lieFontSzie = Math.max(12, Math.round(20 * scale))
    },
    initHeader() {
      setTimeout(() => {
        this.headerShow = true
        this.$set(this, 'showHeader', true)
      }, 200)
      window.addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    },
    handleScroll(e) {
      let direction
      if (e.deltaY !== null || e.deltaY !== '') {
        direction = e.deltaY > 0 ? 'down' : 'up'
      } else {
        this.router.go(0)
      }
      /*   console.log('ssssssssssssssssssssssssss')
         console.log(e.deltaY)*/
      let newScrollTop = 0
      try {
        newScrollTop = this.$refs['homeBody'].$refs['bodyTwo'].scrollTop
      } catch (e) {

      }
      if (direction === 'down') {
        this.cover = true
        onLoadImgInWhere('#bodyTwo', newScrollTop)
        // if (!this.loadImg) {
        //   this.loadImg = true
        // }
      } else if (direction !== 'down' && this.lastScrollTop === 0) {
        this.cover = false
      }

      this.lastScrollTop = newScrollTop
      if (this.cover && direction === 'down') {
        setTimeout(() => {
          this.$set(this, 'showHeader', false)
          this.$set(this, 'showHeader2', true)
          this.$set(this, 'header2Lit', false)
        }, 0)
      } else if (this.cover && direction === 'up') {
        setTimeout(() => {
          this.$set(this, 'header2Lit', true)
        }, 0)
      } else if (!this.cover) {
        setTimeout(() => {
          this.$set(this, 'showHeader', true)
          this.$set(this, 'showHeader2', false)
        }, 0)
      }
    },
  }
}
</script>
<style>
::-webkit-scrollbar{
  width: 0;
}
</style>
<style scoped lang="less">

.all {
  width: 100%;
  overflow: hidden;
}

// 两侧下拉插件定位（px 由 postcss 自动转 vw，随视口等比缩放）
.dropdown-writer {
  position: absolute;
  margin-left: 85px;
  margin-top: 130px;
}

.dropdown-painter {
  position: absolute;
  margin-left: 1850px;
  margin-top: 130px;
}

.block2-offset {
  margin-top: -60px;
}
* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
